<template>
  <div id="album" class="site-container">
    <navigation></navigation>

    <div class="back-link">
      <router-link :to="{ name: 'my-work' }">&larr; Back</router-link>
    </div>

    <!--<div class="grid">
      <div class="item" v-for="img in current.images" :key="img.id" :class="img.class">
        <img :src="'/img/' + current.folder + '/' + img.name">
      </div>
    </div>-->

    <masonry :cols="{default: 3, 767: 2, 495: 1}" :gutter="5">
      <div v-for="(item, index) in current.images" :key="index">
        <img :src="'/img/' + current.folder + '/' + item.name" style="width: 100%;">
      </div>
    </masonry>

    <div class="back-link bottom">
      <router-link :to="{ name: 'my-work' }">&larr; Back</router-link>
    </div>

    <footer>
      <div class="copyright">
        All images &copy; 2018-<span v-text="new Date().getFullYear()"></span> Jovana Ivic
      </div>
    </footer>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Vue from 'vue';
  import Navigation from "../components/Navigation";
  import VueMasonry from 'vue-masonry-css'

  Vue.use(VueMasonry);

  export default {
    name: 'album',
    components: {Navigation},
    watch: {
      '$route'() {
        this.getCurrent();
        window.scrollTo(0, 0);
      }
    },
    data() {
      return {
        categories: [
          {
            slug: 'motorcycle',
            name: 'Motorcycle',
            folder: 'Motorcycle',
            images: [
              {
                'name': 'DSC08975_800.jpg'
              },
              {
                'name': 'DSC09297_800.jpg'
              },
              {
                'name': 'DSC09346_800.jpg'
              },
              {
                'name': 'DSC09359_800.jpg'
              },
              {
                'name': 'DSC09375_800.jpg'
              },
              {
                'name': 'DSC09396_800.jpg'
              },
              {
                'name': 'DSC09427_800.jpg'
              },
              {
                'name': 'DSC09458_800.jpg'
              },
              {
                'name': 'DSC09480_800.jpg'
              },
              {
                'name': 'DSC09486_800.jpg'
              }
            ]
          },
          {
            slug: 'diner',
            name: 'Diner',
            folder: 'Diner',
            images: [
              {
                'name': 'DSC02377_800.jpg',
                'class': 'medium'
              },
              {
                'name': 'DSC02645_800.jpg',
                'class': 'medium'
              },
              {
                'name': 'DSC02821_800.jpg',
                'class': 'medium'
              },
              {
                'name': 'DSC02832_800.jpg',
                'class': 'medium'
              },
              {
                'name': 'DSC02914_800.jpg',
                'class': 'medium'
              },
              {
                'name': 'DSC02990_800.jpg',
                'class': 'medium'
              },
              {
                'name': 'DSC02994_800.jpg',
                'class': 'medium'
              },
              {
                'name': 'DSC03133_800.jpg',
                'class': 'medium'
              },
              {
                'name': 'DSC03139_800.jpg',
                'class': 'medium'
              },
              {
                'name': 'DSC03159_800.jpg',
                'class': 'medium'
              }
            ]
          },
          {
            slug: 'western-darlin',
            name: 'Western Darlin',
            folder: 'WesternDarlin',
            images: [
              {
                'name': 'DSC00472_800.jpg'
              },
              {
                'name': 'DSC00500_800.jpg'
              },
              {
                'name': 'DSC00608_800.jpg'
              },
              {
                'name': 'DSC00663_800.jpg'
              },
              {
                'name': 'DSC00677_800.jpg'
              },
              {
                'name': 'DSC00702_800.jpg'
              },
              {
                'name': 'DSC00760_800.jpg'
              },
              {
                'name': 'DSC00844_800.jpg'
              },
              {
                'name': 'DSC00912_800.jpg'
              },
              {
                'name': 'DSC00961_800.jpg'
              },
              {
                'name': 'DSC01073_800.jpg'
              },
              {
                'name': 'DSC01200_800.jpg'
              },
              {
                'name': 'DSC01391_800.jpg'
              },
              {
                'name': 'DSC01446_800.jpg'
              },
              {
                'name': 'DSC01681_800.jpg'
              },
              {
                'name': 'DSC01698_800.jpg'
              },
              {
                'name': 'DSC01823_800.jpg'
              },
              {
                'name': 'DSC01845_800.jpg'
              },
              {
                'name': 'DSC01910_800.jpg'
              },
              {
                'name': 'DSC02020_800.jpg'
              },
              {
                'name': 'DSC02077_800.jpg'
              },
              {
                'name': 'DSC02166_800.jpg'
              },
              {
                'name': 'DSC02197_800.jpg'
              }
            ]
          },
          {
            slug: 'birthday',
            name: 'Birthday',
            folder: 'Birthday',
            images: [
              {
                'name': 'DSC01688_800.jpg'
              },
              {
                'name': 'DSC01691_800.jpg'
              },
              {
                'name': 'DSC01793_800.jpg'
              },
              {
                'name': 'DSC01817_800.jpg'
              },
              {
                'name': 'DSC01853_800.jpg'
              },
              {
                'name': 'DSC01966_800.jpg'
              },
              {
                'name': 'DSC02002_800.jpg'
              }
            ]
          },
          {
            slug: 'bookstore',
            name: 'Bookstore',
            folder: 'Bookstore',
            images: [
              {
                'name': 'DSC08890_800.jpg'
              },
              {
                'name': 'DSC08978_800.jpg'
              },
              {
                'name': 'DSC09061_800.jpg'
              },
              {
                'name': 'DSC09101_800.jpg'
              },
              {
                'name': 'DSC09156_800.jpg'
              },
              {
                'name': 'DSC09270_800.jpg'
              },
              {
                'name': 'DSC09281_800.jpg'
              },
              {
                'name': 'DSC09304_800.jpg'
              },
              {
                'name': 'DSC09384_800.jpg'
              }
            ]
          },
          {
            slug: 'first-snow',
            name: 'First Snow',
            folder: 'FirstSnow',
            images: [
              {
                'name': 'DSC06290_800.jpg'
              },
              {
                'name': 'DSC06329_800.jpg'
              },
              {
                'name': 'DSC06340_800.jpg'
              },
              {
                'name': 'DSC06358_800.jpg'
              },
              {
                'name': 'DSC06486_800.jpg'
              },
              {
                'name': 'DSC06530_800.jpg'
              },
              {
                'name': 'DSC06566_800.jpg'
              }
            ]
          },
          {
            slug: 'yellow',
            name: 'Yellow',
            folder: 'Yellow',
            images: [
              {
                'name': 'DSC02427_800.jpg'
              },
              {
                'name': 'DSC02430_800.jpg'
              },
              {
                'name': 'DSC02454_800.jpg'
              },
              {
                'name': 'DSC02570_800.jpg'
              },
              {
                'name': 'DSC02658_800.jpg'
              },
              {
                'name': 'DSC02770_800.jpg'
              },
              {
                'name': 'DSC03053_800.jpg'
              },
              {
                'name': 'DSC03228_800.jpg'
              },
              {
                'name': 'DSC03346_800.jpg'
              }
            ]
          },
          {
            slug: 'green',
            name: 'Green',
            folder: 'Green',
            images: [
              {
                'name': 'DSC00439_800.jpg'
              },
              {
                'name': 'DSC00442_800.jpg'
              },
              {
                'name': 'DSC00494_800.jpg'
              },
              {
                'name': 'DSC00901_800.jpg'
              },
              {
                'name': 'DSC00908_800.jpg'
              },
              {
                'name': 'DSC00950_800.jpg'
              },
              {
                'name': 'DSC00992_800.jpg'
              },
              {
                'name': 'DSC01094_800.jpg'
              },
              {
                'name': 'DSC01200_800.jpg'
              },
              {
                'name': 'DSC01265_800.jpg'
              }
            ]
          },
          {
            slug: 'street-lights',
            name: 'Street Lights',
            folder: 'StreetLights',
            images: [
              {
                'name': 'DSC07158_800.jpg'
              },
              {
                'name': 'DSC07295_800.jpg'
              },
              {
                'name': 'DSC07311_800.jpg'
              },
              {
                'name': 'DSC07382_800.jpg'
              },
              {
                'name': 'DSC07400_800.jpg'
              },
              {
                'name': 'DSC07539_800.jpg'
              },
              {
                'name': 'DSC07611_800.jpg'
              },
              {
                'name': 'DSC07636_800.jpg'
              },
              {
                'name': 'DSC07658_800.jpg'
              },
              {
                'name': 'DSC07693_800.jpg'
              }
            ]
          },
          {
            slug: 'family',
            name: 'Family',
            folder: 'Family',
            images: [
              {
                'name': 'DSC07833_800.jpg'
              },
              {
                'name': 'DSC07881_800.jpg'
              },
              {
                'name': 'DSC07893_800.jpg'
              },
              {
                'name': 'DSC08094_800.jpg'
              },
              {
                'name': 'DSC08394_800.jpg'
              },
              {
                'name': 'DSC08466_800.jpg'
              },
              {
                'name': 'DSC08520_800.jpg'
              },
              {
                'name': 'DSC08543_800.jpg'
              },
              {
                'name': 'DSC08581_800.jpg'
              },
              {
                'name': 'DSC08627_800.jpg'
              },
              {
                'name': 'DSC08744_800.jpg'
              }
            ]
          },
          {
            slug: 'couple',
            name: 'Couple',
            folder: 'Couple',
            images: [
              {
                'name': 'DSC03878_800.jpg'
              },
              {
                'name': 'DSC03945_800.jpg'
              },
              {
                'name': 'DSC03979_800.jpg'
              },
              {
                'name': 'DSC04339_800.jpg'
              },
              {
                'name': 'DSC04348_800.jpg'
              },
              {
                'name': 'DSC04363_800.jpg'
              },
              {
                'name': 'DSC04395_800.jpg'
              },
              {
                'name': 'DSC04516_800.jpg'
              }
            ]
          },
          {
            slug: 'headshots',
            name: 'Headshots',
            folder: 'Headshots',
            images: [
              {
                'name': 'DSC07374_800.jpg'
              },
              {
                'name': 'DSC07427_800.jpg'
              },
              {
                'name': 'DSC07496_800.jpg'
              },
              {
                'name': 'DSC07582_800.jpg'
              }
            ]
          },
          {
            slug: 'christmas',
            name: 'Christmas',
            folder: 'Christmas',
            images: [
              {
                'name': 'DSC00006_800.jpg'
              },
              {
                'name': 'DSC00094_800.jpg'
              },
              {
                'name': 'DSC09466_800.jpg'
              },
              {
                'name': 'DSC09523_800.jpg'
              },
              {
                'name': 'DSC09587_800.jpg'
              },
              {
                'name': 'DSC09635_800.jpg'
              },
              {
                'name': 'DSC09673_800.jpg'
              },
              {
                'name': 'DSC09847_800.jpg'
              },
              {
                'name': 'DSC09884_800.jpg'
              },
              {
                'name': 'DSC09939_800.jpg'
              }
            ]
          },
          {
            slug: 'congress-ave',
            name: 'Congress Ave',
            folder: 'CongressAve',
            images: [
              {
                'name': 'DSC03665_800.jpg'
              },
              {
                'name': 'DSC03773_800.jpg'
              },
              {
                'name': 'DSC03879_800.jpg'
              },
              {
                'name': 'DSC03911_800.jpg'
              },
              {
                'name': 'DSC03955_800.jpg'
              },
              {
                'name': 'DSC03981_800.jpg'
              },
              {
                'name': 'DSC04021_800.jpg'
              },
              {
                'name': 'DSC04070_800.jpg'
              },
              {
                'name': 'DSC04079_800.jpg'
              },
              {
                'name': 'DSC04162_800.jpg'
              },
              {
                'name': 'DSC04222_800.jpg'
              }
            ]
          },
          {
            slug: 'poet',
            name: 'Poet',
            folder: 'Poet',
            images: [
              {
                'name': 'DSC04408_800.jpg'
              },
              {
                'name': 'DSC04415_800.jpg'
              },
              {
                'name': 'DSC04600_800.jpg'
              },
              {
                'name': 'DSC04622_800.jpg'
              },
              {
                'name': 'DSC04644_800.jpg'
              },
              {
                'name': 'DSC04663_800.jpg'
              },
              {
                'name': 'DSC04754_800.jpg'
              }
            ]
          }
        ],
        current: {}
      }
    },
    methods: {
      getCurrent() {
        let slug = this.$route.params.slug;
        this.current = _.find(this.categories, ['slug', slug]);
        if (this.current) {
          this.current.images = _.orderBy(this.current.images, 'id', 'desc');
        } else {
          console.error('Category ' + slug + ' not found.');
        }
      },
      loaded() {
        this.$redrawVueMasonry();
      }
    },
    mounted() {
      window.scrollTo(0, 0);
      this.getCurrent();
    },
    destroyed() {
    }
  }
</script>
